var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRetract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(-929.25 -546.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_maximize-3",
    "data-name": "vuesax/outline/maximize-3",
    transform: "translate(180 229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75,21.5h-6C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h6c5.43,0,7.75,2.32,7.75,7.75v6C21.5,19.18,19.18,21.5,13.75,21.5Zm-6-20C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h6C18.36,20,20,18.36,20,13.75v-6c0-4.61-1.64-6.25-6.25-6.25Z",
    transform: "translate(749.25 317.25)",
    fill: "#061133"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(6308 23993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.75,5.5A.755.755,0,0,1,4,4.75V1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h4A.755.755,0,0,1,5.5.75v4A.755.755,0,0,1,4.75,5.5Z",
    transform: "translate(-5362.25 -23436.25) rotate(180)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.75,1.5l-5.833.044a.755.755,0,0,1-.75-.75.755.755,0,0,1,.75-.75L4.75,0A.755.755,0,0,1,5.5.75.755.755,0,0,1,4.75,1.5Z",
    transform: "translate(-5366 -23439.111) rotate(-45)",
    fill: "#061133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716",
    transform: "translate(-4427.75 -22879.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.75,5.5A.755.755,0,0,1,4,4.75V1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h4A.755.755,0,0,1,5.5.75v4A.755.755,0,0,1,4.75,5.5Z",
    transform: "translate(-5362.25 -23436.25) rotate(180)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M4.75,1.5l-5.833.044a.755.755,0,0,1-.75-.75.755.755,0,0,1,.75-.75L4.75,0A.755.755,0,0,1,5.5.75.755.755,0,0,1,4.75,1.5Z",
    transform: "translate(-5366 -23439.111) rotate(-45)",
    fill: "#061133"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetract);
export default __webpack_public_path__ + "static/media/Icon-retract.ba58733e4a2e3ad7ac8ab7b5c49f2319.svg";
export { ForwardRef as ReactComponent };